var React					= require('react'),
	_						= require('lodash'),
	toClassString 			= require('fdna-common-components/dist/libs/utils').toClassString,
	AuthMiddleware			= require('../../../authMiddleware/authMiddleware');

function HipaaCompoliant(props, context){
	return (
		<div className={toClassString('hipaa-compliant', props.className)}>
			HIPAA & GDPR COMPLIANT
			<span className="icon icon-lock" />
			<AuthMiddleware />
		</div>
	);
}

module.exports = HipaaCompoliant;


// WEBPACK FOOTER //
// ./common/components/HipaaCompliant/HipaaCompliant.jsx